import React from 'react';
import '../styles/ImageGallery.css';
import image1 from '../../../images/e.jpg';
import image2 from '../../../images/e-1.jpg';
import image3 from '../../../images/e-2.jpg';

const ImageGallery = () => {
    return (
        <div className="image-gallery">
            <img className='gallery-item' src={image1} alt="1" />
            <img className='gallery-item' src={image2} alt="2" />
            <img className='gallery-item' src={image3} alt="3" />
        </div>
    );
}

export default ImageGallery;